module.exports = __webpack_public_path__ + "img/search.9e2c4b3a.svg";